import {RadioGroup} from '@smart/react-components';
import React, {useContext} from 'react';
import type {StringSchema} from 'yup';
import type {Maybe} from '../../../graphql';
import {FieldContext} from './field-wrapper';
import type {ICommonFieldProps, IWrapperProvider} from './types';
import {useFieldSetup} from './use-field-setup';

type RadioInputProps = React.ComponentProps<typeof RadioGroup.Radio>;

interface IProps extends ICommonFieldProps {
  name: string;
  initial?: boolean;
  props?: Partial<RadioInputProps>;
  schema?: StringSchema;
  label?: Maybe<string>;
}

const RadioField = function ({
  tag,
  initial = false,
  required,
  schema,
  label,
}: IProps) {
  const {getLabel, genericHandler, disabled, state} =
    useContext<IWrapperProvider>(FieldContext as any);

  useFieldSetup(tag, initial ? Date.now() : 0, schema);

  const handler = (event: React.SyntheticEvent) => {
    event.preventDefault();
    genericHandler(tag, Date.now());
  };

  const selected = Object.entries(state).reduce(
    (prev, curr) => ((curr[1] as number) > (prev[1] as number) ? curr : prev),
    [``, 0],
  )[0];

  return tag in state ? (
    <RadioGroup.Radio
      key={tag}
      value={``}
      checked={selected === tag}
      onClick={handler}
      disabled={disabled}
    >
      {getLabel(tag, required, label)}
    </RadioGroup.Radio>
  ) : null;
};

export default RadioField;
